import React, { Component } from 'react'
import ReactTable from 'react-table'
import { Row, Col } from 'reactstrap'
import { Button } from 'components'

import { tableHeaders } from '../../views/Configurator/tableHeaders'
import { Badge } from 'antd'

class ConfiguratorTable extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: [],
    }
  }

  formatBudgets() {
    const euro = Intl.NumberFormat('es-ES', {
      style: 'currency',
      currency: 'EUR',
    })
    let formattedData
    if (this.props.budgets.length > 0) {
      formattedData = this.props.budgets.map(budget => ({
        id: budget.client_id,
        name: budget.client_name,
        phone: budget.client_phone,
        services: (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
            }}
          >
            {budget.products_internet && (
              <i className="now-ui-icons business_globe" />
            )}
            {budget.products_television && (
              <i className="now-ui-icons tech_tv" />
            )}
            {budget.products_phone && (
              <span
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '4px',
                }}
              >
                <Badge
                  size="small"
                  color="#46b98a"
                  count={budget.products_phone}
                >
                  <i className="now-ui-icons tech_mobile" />
                </Badge>
              </span>
            )}
          </div>
        ),
        total: euro.format(Number(budget.products_total)),
        actions: (
          <a href={budget.budget_url} target="_blank" rel="noopener noreferrer">
            <Button round icon>
              <i className="now-ui-icons arrows-1_minimal-right" />
            </Button>
          </a>
        ),
      }))
    }
    return formattedData
  }
  render() {
    return (
      <div className="content">
        <Row>
          <Col xs={12} md={12}>
            <ReactTable
              data={this.formatBudgets()}
              columns={tableHeaders}
              filterable
              defaultPageSize={10}
              className="-striped -highlight"
            />
          </Col>
        </Row>
      </div>
    )
  }
}

export default ConfiguratorTable



// WEBPACK FOOTER //
// ./src/components/Configurator/ConfiguratorTable.jsx